import { LongRunningAction } from "@shared/decorators/long-running-action.decorator";
import { NgxsActionName } from "@shared/constants";
import { NgxsCallBacks } from "@shared/stores/store.callbacks";

export class SetIsCommonDataLoaded {
  static readonly type = '[CommonData] Set Is Common Data Loaded';
  constructor() { }
}

@LongRunningAction(NgxsActionName.GET_USER_PROFILE_ME)
export class GetUserProfileMe {
  static readonly type = '[CommonData] Get User Profile Me';
  constructor(public hackApexId: string = "") { }
}

@LongRunningAction(NgxsActionName.GET_ORG_TERMINAL_LIST)
export class GetOrgTerminalList {
  static readonly type = '[CommonData] Get Org Terminal List';
  constructor(public terminalId: string) { }
}

@LongRunningAction(NgxsActionName.GET_DRIVER_RELATED_TERMINAL_LIST)
export class GetDriverRelatedTerminalList {
  static readonly type = '[CommonData] Get Driver Related Terminal List';
  constructor() { }
}

@LongRunningAction(NgxsActionName.GET_SUB_REGION_RELATED_TERMINAL_LIST)
export class GetSubRegionRelatedTerminalList {
  static readonly type = '[CommonData] Get Sub Region Related Terminal List';
  constructor() { }
}

@LongRunningAction(NgxsActionName.GET_SUB_REGIONS)
export class GetSubRegions {
  static readonly type = '[CommonData] Get Sub Regions';
  constructor() { }
}

@LongRunningAction(NgxsActionName.GET_USER_PROFILE_ROLE, NgxsCallBacks.GetUserProfileRole)
export class GetUserProfileRole {
  static readonly type = '[CommonData] Get User Profile Role';
  constructor() { }
}

@LongRunningAction(NgxsActionName.GET_KPI_ALL)
export class GetKpiAll {
  static readonly type = '[CommonData] Get Kpi All';
  constructor() { }
}

@LongRunningAction(NgxsActionName.SEARCH_DRIVERS_WITH_MY_PROFILE)
export class SearchDriversWithMyProfile {
  static readonly type = '[CommonData] Search Drivers With My Profile';
  constructor(public driverApexIdOrName: string = '') { }
}

@LongRunningAction(NgxsActionName.VALIDATE_USER_PROFILE, NgxsCallBacks.GetUserProfile)
export class ValidateUserProfile {
  static readonly type = '[CommonData] Validate User Profile';
  constructor(public apexID: string = '') { }
}
